export const dataInformesPELE = [
  {
    id: 1,
    year: "2024",
    monthDoc: "Septiembre - Noviembre",
    title: "INFORME ÚNICO EN MATERIA DE ENCUESTA ELECTORALES PELE 2024",
    link: "https://itetlax.org.mx/assets/pdf/informesPELE2024/1.pdf",
  },
];
